import { Link } from 'react-router-dom';

/**
 * External URLs that require full page navigation (different React apps)
 */
const EXTERNAL_PATHS = [
    '/hr',
    '/admin',
    '/clients',
    '/ping',
    '/classroom',
    '/website-builder'
];

/**
 * Smart navigation component that uses:
 * - React Router <Link> for internal navigation (SPA)
 * - Regular <a> for external apps (full page reload)
 */
const NavLink = ({ to, children, className, onClick, ...props }) => {
    // Check if this URL goes to a different React app
    const isExternal = EXTERNAL_PATHS.some(path =>
        to === path || to.startsWith(path + '/') || to.startsWith(path + '?')
    );

    if (isExternal) {
        return (
            <a href={to} className={className} onClick={onClick} {...props}>
                {children}
            </a>
        );
    }

    // Internal navigation - use React Router
    return (
        <Link to={to} className={className} onClick={onClick} {...props}>
            {children}
        </Link>
    );
};

export default NavLink;
